import React, { useEffect } from 'react';
import dayjs from 'dayjs';
import _ from 'lodash';
import objectSupport from 'dayjs/plugin/objectSupport';
import Button from '@material-ui/core/Button';

import PropTypes from 'prop-types';

import {
    Text,
    StyledCard,
    StyledCardContent,
    GroupIcon,
    HorizontalRule,
    CalendarIcon,
    EditIcon,
    Avatar,
    OutlinedButton,
    FilledIconButton,
    CopyIcon,
} from '../../index';

dayjs.extend(objectSupport);

export const SessionDetailCard = ({ data, onDuplicate, onEdit, showStaff, children, disabled }) => {
    return (
        <StyledCard padding="15px 24px" style={{ position: 'relative' }}>
            <StyledCardContent style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
                <div
                    style={{
                        display: 'grid',
                        alignItems: 'start',
                        gridTemplateColumns: '1fr auto',
                    }}
                >
                    <Text $bold $fontSize="18px" $ellipsis>
                        Activity name - {data?.name}
                    </Text>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            columnGap: '8px',
                        }}
                    >
                        {onDuplicate && data.type !== 'open' && (
                            <FilledIconButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDuplicate();
                                }}
                                $backgroundColor="green"
                                style={{
                                    margin: 0,
                                    width: '32px',
                                    height: '32px',
                                    justifySelf: 'end',
                                }}
                            >
                                <CopyIcon fill="white" />
                            </FilledIconButton>
                        )}
                        {!disabled && onEdit && (
                            <OutlinedButton
                                $color="gray2"
                                $width="78px"
                                $borderWidth="1.5px"
                                $padding="0"
                                onClick={onEdit}
                                disabled={disabled}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        columnGap: '3px',
                                    }}
                                >
                                    <EditIcon width="20px" height="20px" fill="gray2" />
                                    <Text $color="gray2">Edit</Text>
                                </div>
                            </OutlinedButton>
                        )}
                    </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', columnGap: '5px' }}>
                    <CalendarIcon fill="pink" width="16px" height="16px" />
                    <Text $color="pink" $fontSize="12px" $bold>
                        {!_.isEmpty(data) &&
                            `${
                                dayjs(data.startDate).isSame(dayjs(), 'day')
                                    ? 'Today'
                                    : dayjs(data.startDate).format('DD MMM YYYY')
                            }, ${dayjs()
                                .set({
                                    hour: data.startTime.split(':')[0],
                                    minute: data.startTime.split(':')[1],
                                })
                                .format('HH:mm')} - ${dayjs()
                                .set({
                                    hour: data.endTime.split(':')[0],
                                    minute: data.endTime.split(':')[1],
                                })
                                .format('HH:mm')}`}
                    </Text>
                </div>
                {!_.isEmpty(data?.patients) && (
                    <div style={{ display: 'flex', alignItems: 'center', columnGap: '5px' }}>
                        <GroupIcon fill="purple" width="16px" height="16px" />
                        <Text $color="purple" $fontSize="12px">
                            {data?.patients?.length} Participants
                        </Text>
                    </div>
                )}

                {showStaff && (
                    <div style={{ display: 'flex', columnGap: '10px', alignItems: 'center' }}>
                        <Avatar
                            src={data?.staff?.user?.avatar?.url}
                            alt={data?.staff?.user?.fullname}
                            $avatarSize="30px"
                        />
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Text $color="gray1" $fontSize="12px">
                                {data?.staff?.user?.fullname}
                            </Text>
                            <Text $color="gray1" $fontSize="10px">
                                {data?.hospital?.name}
                            </Text>
                        </div>
                    </div>
                )}
                <HorizontalRule style={{ marginTop: '10px', marginBottom: '10px' }} />
                <Text $fontSize="12px" $color="gray2">
                    {data?.description}
                </Text>
                {children}
            </StyledCardContent>
        </StyledCard>
    );
};

SessionDetailCard.propTypes = {
    data: PropTypes.object,
    onEdit: PropTypes.func,
    showStaff: PropTypes.bool,
    children: PropTypes.any,
    disabled: PropTypes.bool,
};
